import axios from "@/lib/axios";

export type DownloadResultsFileRequestParams = {
  companyId: string;
  applicationQuizId: string;
};

export type DownloadResultsFileResponse = Blob;

export const downloadResultsFileRequest = (
  params: DownloadResultsFileRequestParams,
) =>
  axios.get<DownloadResultsFileResponse>(
    `/v1/companies/${params.companyId}/reports/${params.applicationQuizId}/download-result`,
    {
      responseType: "blob",
    },
  );
